import React from 'react';
import PillTabs from '../shared/PillTabs';

/**
 * AuthSegmentedControl
 * Thin wrapper around PillTabs for the Student / Staff toggle on LoginPage.
 * Tap targets are ≥44px via PillTabs' py:0.75 + px:2 + caption height.
 *
 * @param {Array<{ key: string, label: string, icon?: ReactNode }>} tabs
 * @param {string} value - active tab key
 * @param {(key: string) => void} onChange
 */
function AuthSegmentedControl({ tabs, value, onChange }) {
  return (
    <PillTabs
      tabs={tabs}
      value={value}
      onChange={onChange}
      fullWidth
      variant="filled"
    />
  );
}

export default AuthSegmentedControl;
